var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKustomLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 679"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kustom-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 215.8h1499.7v247.4H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "kustom-logo_svg__b",
    x: 0,
    y: 215.8,
    width: 1499.7,
    height: 247.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1499.7 215.8H0v247.4h1499.7V215.8z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#kustom-logo_svg__b)",
    clipPath: "url(#kustom-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.6 382.5c0 6.5-5.3 11.5-11.8 11.5s-12.2-5.1-12.2-11.5V277.3h-96.8v118.1c0 44.7 24.4 67.7 64.8 67.7s47.5-9.5 58.7-24.3v18.5h94.1v-180h-96.8v105.2zM631.5 332.5c0-5.8 4.1-8.3 11.1-8.3s12.6 4.7 12.6 14.1h84.1c0-27.4-16.4-67-100.7-67s-97 23-97 59.4c0 75.6 109.4 47.2 109.4 71.3s-4.5 8.3-11.5 8.3-13.4-5.8-13.4-14.4h-86.3c1.1 45.4 40.9 67.3 100.4 67.3S745 451.7 745 401.6s-113.5-45-113.5-69.1zM236.6 343.6l62.5-69.5-77.3-58.3-67.8 81.4v-71.7H54.9v70.2H0v86.8h54.9v74.9H154v-71c25.1 20.2 39.2 43.6 44.6 71h107.8c-8.4-43.9-31.2-81.8-69.7-113.8zM871.1 233.8h-97.2v43.6h-27.8v60.9h27.8v48.6c0 47.5 27.8 70.6 84.2 70.6h50.7v-72.7h-28.2c-5.7 0-9.5-4-9.5-9.4v-37.1h37.7v-60.9h-37.7v-43.6zM1034.5 384.1c-9.5 0-16.8-7.4-16.8-17.1s7.2-16.7 16.8-16.7 16.4 7.4 16.4 16.7-7.2 17.1-16.4 17.1zm-.3-112.9c-67.1 0-113.9 38.9-113.9 95.4s44.9 96.5 113.5 96.5 114.3-38.9 114.3-96.5-46.1-95.4-113.9-95.4zM1430 271.2c-22.1 0-46 5.6-59.1 26.9-10.7-17.6-28.8-26.9-51-26.9s-47.7 8.6-61.3 29.7v-23.6h-94.5v180.1h96V358c0-6.1 5.3-11.2 12.2-11.2s11.8 5.1 11.8 11.2v99.4h95.3V358c0-6.1 5.3-11.2 12.2-11.2s11.8 5.1 11.8 11.2v99.4h96.4V338.2c0-40-28.2-67-69.7-67z"
  }))));
}
export default SvgKustomLogo;